module.exports = __webpack_public_path__ + "static/img/secondSwiper.022fe79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secondSwiper.png
// module id = Fv6z
// module chunks = 1